import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreChat } from '../../../Types/StoreTypes';
import { Chat } from '../../../Types';

const initialState: StoreChat = {
    chat: {} as Chat,
    chatMessages: {},
    isSending: false,
    isNewChat: false,
    chatLoaded: false,
    messagesLoaded: false,
    prompts: [],
    websocketError: false,
    isStopable: false,
    updateChat: false,
    storedMessages: [],
    chatContainerStyles:
        parseInt(localStorage.getItem('chatContainerWidth') ?? '0') >= 450
            ? { maxWidth: parseInt(localStorage.getItem('chatContainerWidth') || '0') + 'px' }
            : {},
};

const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        setChat: (state, action: PayloadAction<Partial<StoreChat['chat']>>) => {
            state.chat = { ...state.chat, ...action.payload };
        },
        setIsSending: (state, action: PayloadAction<StoreChat['isSending']>) => {
            state.isSending = action.payload;
        },
        setIsNewChat: (state, action: PayloadAction<StoreChat['isNewChat']>) => {
            state.isNewChat = action.payload;
        },
        setChatLoaded: (state, action: PayloadAction<StoreChat['chatLoaded']>) => {
            state.chatLoaded = action.payload;
        },
        setMessagesLoaded: (state, action: PayloadAction<StoreChat['messagesLoaded']>) => {
            state.messagesLoaded = action.payload;
        },
        setWebsocketError: (state, action: PayloadAction<StoreChat['websocketError']>) => {
            state.websocketError = action.payload;
        },
        setIsStopable: (state, action: PayloadAction<StoreChat['isStopable']>) => {
            state.isStopable = action.payload;
        },
        setChatDlpActive: (state, action: PayloadAction<StoreChat['chat']['dlp_active']>) => {
            state.chat.dlp_active = action.payload;
        },
        setUpdateChat: (state, action: PayloadAction<StoreChat['updateChat']>) => {
            state.updateChat = action.payload;
        },
        setChatMessages: (state, action: PayloadAction<any>) => {
            if(!state.chatMessages[action.payload.chatIdentifier]){
                state.chatMessages[action.payload.chatIdentifier] = {}
            }
            state.chatMessages[action.payload.chatIdentifier] = action.payload.payload;
        },
        setChatContainerStyles: (state, action: PayloadAction<any>) => {
            state.chatContainerStyles = action.payload;
        },
        setChatDlp: (state, action: PayloadAction<StoreChat['chat']['dlp']>) => {
            state.chat.dlp = action.payload;
        },
        updateMessageMetadata: (state, action: PayloadAction<any>) => {
            if ((state.chatMessages[action.payload.chatIdentifier] ?? {})[action.payload.identifier]) {
                state.chatMessages[action.payload.chatIdentifier][action.payload.identifier] = {
                    ...state.chatMessages[action.payload.chatIdentifier][action.payload.identifier],
                    ...action.payload,
                };
            }
        },
        updateMessage: (state, action: PayloadAction<any>) => {
            if (!state.chatMessages[action.payload.chatIdentifier]) {
                state.chatMessages[action.payload.chatIdentifier] = {}
            }
            state.chatMessages[action.payload.chatIdentifier][action.payload.identifier] = {
                ...state.chatMessages[action.payload.chatIdentifier][action.payload.identifier],
                ...action.payload,
            };
        },
        addMessage: (state, action: PayloadAction<any>) => {
            if (!state.chatMessages[action.payload.chatIdentifier]) {
                state.chatMessages[action.payload.chatIdentifier] = {}
            }
            state.chatMessages[action.payload.chatIdentifier][action.payload.identifier] = action.payload;
        },
        addStoredMessage: (
            state,
            action: PayloadAction<{ chatId: string; message: string; images?: any[]; files?: any[] }>,
        ) => {
            const existingIndex = state.storedMessages.findIndex((msg) => msg.chatId === action.payload.chatId);
            if (existingIndex !== -1) {
                state.storedMessages[existingIndex] = action.payload;
            } else {
                state.storedMessages.push(action.payload);
            }
        },
    },
});

export const {
    setChat,
    setIsSending,
    setIsNewChat,
    setChatLoaded,
    setMessagesLoaded,
    setWebsocketError,
    setIsStopable,
    setChatDlpActive,
    setUpdateChat,
    setChatMessages,
    setChatContainerStyles,
    setChatDlp,
    updateMessageMetadata,
    updateMessage,
    addMessage,
    addStoredMessage,
} = chatSlice.actions;

export default chatSlice.reducer;
